import React from 'react';
import { wrapReactionHook } from "../../hooks";
import { Button as AntButton } from 'antd';
export var Button = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(AntButton, props, children);
});